import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { IOnTap2 } from 'app/models/on-tap';
import * as Action from './actions'

export interface State extends EntityState<IOnTap2> {
  // additional entity state properties
  selectedId: string | null;
  error: string;
}


export function sortByName(a: IOnTap2, b: IOnTap2): number {
  if (!a || !b) return 0;
  if (!a.name && !b.name) return 0;
  if (!a.name) return -1;
  if (!b.name) return 1;
  return a.name.localeCompare(b.name);
}
export function selectId(a: IOnTap2): string {
  return a && a.id ? a.id : '';
}
export const adapter: EntityAdapter<IOnTap2> = createEntityAdapter<IOnTap2>({
  sortComparer: sortByName,
  selectId: selectId
});

export const initialState: State = adapter.getInitialState({
  selectedId: null,
  error: ''
});

export const stateName = 'ontapadvanced';

export const reducer = createReducer<State>(
  initialState,
  on(Action.clearAllItems, (state) => {
    return adapter.removeAll(state);
  }),
  on(Action.loadItemsSuccess, (state, { items }) => {
    return adapter.setAll(items, state);
  }),
  on(Action.setItem, (state, action) => Object.assign({ ...state, selectedId: action.id })),
  on(Action.setItemFromListPage, (state, action) => Object.assign({ ...state, selectedId: action.id }))

);

// get the selectors
const { selectAll, selectEntities } = adapter.getSelectors();

// Export selectAll for effect caching
export { selectAll };
const getState = createFeatureSelector<State>(stateName);
export const getSelectedId = (state: State) => state.selectedId;
export const selectCurrentId = createSelector(getState, getSelectedId);

const onTapBasicState = createFeatureSelector<State>(stateName);
export const selectAllItems = createSelector(onTapBasicState, selectAll);
export const selectAllEntities = createSelector(onTapBasicState, selectEntities);
export const selectEntity = (id: string) => createSelector(selectAllEntities, entities => entities[id]);
export const selectCurrentItem = createSelector(selectAllEntities, selectCurrentId, (entities, id) => {
  if (id) return entities[id];
  return null;
});
